import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const DeveloperToolsPage = lazy(() =>
  import('./routes/DeveloperToolsPage').then((m) => ({ default: m.DeveloperToolsPage })),
);
const DeveloperPricingPage = lazy(() =>
  import('./routes/DeveloperPricingPage').then((m) => ({ default: m.DeveloperPricingPage })),
);
const ApiConsolePage = lazy(() =>
  import('./routes/ApiConsolePage').then((m) => ({ default: m.ApiConsolePage })),
);
const ApiKeyDetailPage = lazy(() =>
  import('./routes/ApiKeyDetailPage').then((m) => ({ default: m.ApiKeyDetailPage })),
);
const BrandApiDocsPage = lazy(() =>
  import('./routes/BrandApiDocsPage').then((m) => ({ default: m.BrandApiDocsPage })),
);
const McpProtocolPage = lazy(() =>
  import('./routes/McpProtocolPage').then((m) => ({ default: m.McpProtocolPage })),
);
const McpProtocolDetailPage = lazy(() =>
  import('./routes/McpProtocolDetailPage').then((m) => ({ default: m.McpProtocolDetailPage })),
);
const DeveloperIntegrationsPage = lazy(() =>
  import('./routes/DeveloperIntegrationsPage').then((m) => ({
    default: m.DeveloperIntegrationsPage,
  })),
);
const RequestDeveloperAccessPage = lazy(() =>
  import('./routes/RequestDeveloperAccessPage').then((m) => ({
    default: m.RequestDeveloperAccessPage,
  })),
);
const ApiDocumentationPage = lazy(() =>
  import('./routes/ApiDocumentationPage').then((m) => ({ default: m.ApiDocumentationPage })),
);
const McpDocumentationPage = lazy(() =>
  import('./routes/McpDocumentationPage').then((m) => ({ default: m.McpDocumentationPage })),
);

/**
 * Developer Tools: the key list, one key, the console, pricing, the MCP screens, integrations and
 * the documentation.
 *
 * <p>**Listed inside the `<ProductRoute />` group in `app/router`.** Every path except the
 * request-access form is registered in `app/navigation/screens.ts` against `brand_api`, so the
 * group demands the product by placement; the request-access form names no product, because it
 * is how somebody who lacks it asks. The screens call the previous system's key and billing
 * endpoints, which this backend does not have yet, so they load and fail their requests until it
 * does.
 */
export const developerRoutes: RouteObject[] = [
  { path: ROUTES.developerTools, element: <DeveloperToolsPage /> },
  { path: ROUTES.developerPricing, element: <DeveloperPricingPage /> },
  { path: ROUTES.apiConsole, element: <ApiConsolePage /> },
  { path: ROUTES.apiKeyDetail, element: <ApiKeyDetailPage /> },
  { path: ROUTES.developerApiDocumentation, element: <ApiDocumentationPage /> },
  { path: ROUTES.developerMcpDocumentation, element: <McpDocumentationPage /> },
  { path: ROUTES.brandApiDocs, element: <BrandApiDocsPage /> },
  { path: ROUTES.developerMcp, element: <McpProtocolPage /> },
  { path: ROUTES.mcpProtocolDetail, element: <McpProtocolDetailPage /> },
  { path: ROUTES.developerIntegrations, element: <DeveloperIntegrationsPage /> },
  { path: ROUTES.developerRequestAccess, element: <RequestDeveloperAccessPage /> },
];
